import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const WOOD_PIECES_ACTIVITY_FRAGMENT = gql `
  fragment WoodPiecesActivityFragment on WoodPiecesActivity {
    rounds {
      affirmationAudio {
        ...AssetFragment
      }
      completedAudio {
        ...AssetFragment
      }
      instructionAudio {
        ...AssetFragment
      }
      introductionAudio {
        ...AssetFragment
      }
      letter
      steps {
        stepsPosition: position {
          r
          x
          y
        }
        stroke
        strokeAudio {
          ...AssetFragment
        }
        strokeImage {
          ...AssetFragment
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default WOOD_PIECES_ACTIVITY_FRAGMENT;
